var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiOps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37497_74556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.69 13.52C6.8551 13.7702 7.08139 13.9742 7.3474 14.1124C7.61341 14.2507 7.91033 14.3187 8.21 14.31M8.21 14.31C8.6193 14.3462 9.02637 14.2195 9.3428 13.9574C9.65923 13.6953 9.85946 13.3189 9.9 12.91C9.86193 12.4993 9.66275 12.1204 9.34605 11.8562C9.02934 11.5919 8.62087 11.4639 8.21 11.5C7.80077 11.5334 7.39488 11.404 7.08038 11.1401C6.76588 10.8761 6.56812 10.4988 6.53 10.09C6.57058 9.68299 6.76939 9.30819 7.08362 9.04634C7.39784 8.78449 7.80234 8.65652 8.21 8.69M8.21 14.31V15.25M8.21 8.69C8.51014 8.6784 8.80813 8.74514 9.07464 8.88366C9.34116 9.02218 9.56702 9.2277 9.73 9.48M8.21 8.69V7.75M14 15.25V12.25M17.5 15.25V9.25M1.5 0.75H22.5C22.5 0.75 23.25 0.75 23.25 1.5V4C23.25 4 23.25 4.75 22.5 4.75H1.5C1.5 4.75 0.75 4.75 0.75 4V1.5C0.75 1.5 0.75 0.75 1.5 0.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.25V18M12 22.25C12.83 22.25 13.5 22.7 13.5 23.25M12 22.25C11.17 22.25 10.5 22.7 10.5 23.25M0.75 18H23.25M2.25 4.75H21.75V18H2.25V4.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37497_74556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiOps);
export default __webpack_public_path__ + "static/media/BIOps.0353d4ac9689ba57f6ebdd3ec6130c80.svg";
export { ForwardRef as ReactComponent };